export { OrderCompletedModal, OrderCompletedModalWithStyles, OrderCompletedModalWithTheme } from './OrderCompletedModal'
